<div class="promise-to-pay-settings">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>Promise to Pay</mat-card-title>
      <mat-card-subtitle>Select the LM Credit employees granted each Promise to Pay permission</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <div class="toolbar">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [(ngModel)]="searchText" (ngModelChange)="applyFilter()" placeholder="Name or position" />
        </mat-form-field>
        <mat-slide-toggle color="primary" [(ngModel)]="selectedOnly" (change)="applyFilter()">
          Selected only
        </mat-slide-toggle>
      </div>

      <div *ngIf="isLoading" class="loading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <div class="table-container" [hidden]="isLoading">
        <table mat-table [dataSource]="dataSource" matSort class="flat-table">
          <ng-container matColumnDef="full_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let employee">{{ employee.full_name }}</td>
          </ng-container>

          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Position</th>
            <td mat-cell *matCellDef="let employee">{{ employee.position }}</td>
          </ng-container>

          <ng-container *ngFor="let column of permissionColumns" [matColumnDef]="column.key">
            <th mat-header-cell *matHeaderCellDef class="permission-cell">
              <div class="permission-label">{{ column.label }}</div>
              <div class="permission-hint">{{ column.hint }} · {{ count(column.key) }} selected</div>
            </th>
            <td mat-cell *matCellDef="let employee" class="permission-cell">
              <mat-checkbox
                color="primary"
                [checked]="isSelected(employee, column.key)"
                (change)="toggle(employee, column.key)">
              </mat-checkbox>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let employee; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">No matching employees</td>
          </tr>
        </table>
      </div>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isLoading || isSaving">
        <mat-spinner *ngIf="isSaving" diameter="16" class="btn-spinner"></mat-spinner>
        <span *ngIf="!isSaving">Save</span>
      </button>
    </mat-card-actions>
  </mat-card>
</div>
